import { useAct } from 'DashboardUser/store'
import Loading from 'Shared/components/Loading'

import DashboardTargetTable from './DashboardTargetTable'
import DashboardInstructions from './DashboardInstructions'
import { RingroundSnackbar } from 'Shared/components'

export default function PageContainer({ dashboardId }) {
  const act = useAct()
  const currentPage = useSel(s => s.local.currentPage)
  const [showInstructions, setShowInstructions] = useState(false)

  useEffect(() => {
    if (!dashboardId) return

    act.app.load(dashboardId)
    act.app.loadMe()
    act.app.reloadTargets()

    const storageKey = `dashboard-instructions-viewed-${dashboardId}`
    const hasViewed = localStorage.getItem(storageKey)
    setShowInstructions(!hasViewed)
    localStorage.setItem(storageKey, 'true')
  }, [dashboardId])

  useEffect(() => {
    act.app.reloadTargets()
  }, [currentPage])

  const name = useSel(s => s.dashboard.name)
  const instructions = useSel(s => s.dashboard.instructions)
  const loaded = useSel(s => s.app.loaded)

  return <div className='dashboard-user-root'>
    <RingroundSnackbar />
    <div className='topbar'>
      <a className='back' href='/'></a>
      <h1 className='dashboard-title'>{name}</h1>
      {instructions && !showInstructions && (
        <button className='button primary instructions-button' onClick={() => setShowInstructions(true)}>Instructions</button>
      )}
    </div>

    {instructions && showInstructions && (
      <DashboardInstructions onClose={setShowInstructions} />
    )}
    <div className='content'>
      {loaded ? <DashboardTargetTable /> : <Loading />}
    </div>
  </div>
}
